import { useEffect } from "react";

const OVERLAY_SELECTOR =
  ".modal-overlay, .blocking-action-overlay, .photo-lightbox";

function clearDocumentScrollLock(previousOverflow = "") {
  if (typeof document === "undefined") return;
  document.body.style.overflow = previousOverflow || "";
  delete document.body.dataset.scrollLocked;
  const root = document.getElementById("root");
  if (root && !document.querySelector(".blocking-action-overlay")) {
    root.inert = false;
  }
}

/**
 * While any modal / blocking overlay / lightbox is in the DOM, lock document
 * scroll so wheel/touch on the blurred backdrop does not move the page behind.
 */
export function ModalBodyScrollLock() {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    let locked = false;
    let previousOverflow = "";

    const sync = () => {
      const open = Boolean(document.querySelector(OVERLAY_SELECTOR));
      if (open && !locked) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        document.body.dataset.scrollLocked = "1";
        locked = true;
      } else if (!open && locked) {
        clearDocumentScrollLock(previousOverflow);
        previousOverflow = "";
        locked = false;
      } else if (!open && document.body.dataset.scrollLocked === "1") {
        // Safety: unlock leftovers if a close path skipped the observer.
        clearDocumentScrollLock("");
      }
    };

    sync();
    const obs = new MutationObserver(sync);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => {
      obs.disconnect();
      if (locked || document.body.dataset.scrollLocked === "1") {
        clearDocumentScrollLock(previousOverflow);
      }
    };
  }, []);

  return null;
}
